export default "__VITE_ASSET__Bvcs4NTF__"